export { BuildingIcon } from './building'
